// 引用api文件
import api from "../index";
/**
 * @author yangluyao
 * @date 2020-02-24
 * @Description: 执法机构模块
 */
// 获取当前登录用户可看到的部门
export function getDept(data, success, failure, menuId) {
  return api.postFormData(
    "hzf-admin/sys/dept/getDeptListByLoginUser",
    data,
    success,
    failure,
    menuId
  );
}
// 删除部门
export function delDept(data, success, failure, menuId) {
  return api.postFormData(
    "hzf-admin/sys/dept/deleteOneDept",
    data,
    success,
    failure,
    menuId
  );
}
// 新增部门
export function addDept(data, success, failure, menuId) {
  return api.postFormData(
    "hzf-admin/sys/dept/saveOneDept",
    data,
    success,
    failure,
    menuId
  );
}
// 修改部门
export function updateDept(data, success, failure, menuId) {
  return api.postFormData(
    "hzf-admin/sys/dept/updateDept",
    data,
    success,
    failure,
    menuId
  );
}
// 根据部门id获取部门信息
export function getDeptInfoById(data, success, failure, menuId) {
  return api.post(
    "hzf-admin/sys/dept/getDeptInfoByDeptIds",
    data,
    success,
    failure,
    menuId
  );
}
